import React, { useState } from "react";
import { Image as ImageIcon, MousePointerClick } from "lucide-react";
import { BrowserFrame } from "@/components/mockups/primitives";
import { Mockup, PHONE_MOCKUPS } from "@/components/mockups";
import { cn } from "@/lib/utils";

// Shows the real app.fixlr.app screenshot when one exists, with a toggle to the interactive mockup.
export const ProductFrame = ({ shot, mockup, url = "app.fixlr.app", alt, glow, className, testId = "product-frame" }) => {
  const hasShot = Boolean(shot);
  const hasMockup = Boolean(mockup);
  const [mode, setMode] = useState(hasShot ? "shot" : "mockup");

  if (!hasShot && PHONE_MOCKUPS.has(mockup)) return <div className="py-6 flex justify-center"><Mockup name={mockup} /></div>;

  return (
    <div className={cn("relative min-w-0", className)} data-testid={testId}>
      {hasShot && hasMockup && (
        <div className="absolute -top-3 right-4 z-10 inline-flex items-center rounded-full border border-mk-border bg-mk-bg/90 backdrop-blur p-0.5 text-[11px] font-medium shadow-lg" data-testid={`${testId}-toggle`}>
          {[["shot", "Live screenshot", ImageIcon], ["mockup", "Interactive", MousePointerClick]].map(([k, l, I]) => (
            <button key={k} type="button" onClick={() => setMode(k)} data-testid={`${testId}-${k}`} className={cn("inline-flex items-center gap-1.5 rounded-full px-3 py-1 transition-colors", mode === k ? "bg-mk-lime text-mk-bg" : "text-mk-dim hover:text-mk-text")}>
              <I className="h-3 w-3" />{l}
            </button>
          ))}
        </div>
      )}
      {mode === "shot" ? (
        <BrowserFrame url={url} className={cn(glow && "glow-lime")} bodyClass="!p-0 !overflow-hidden">
          <img src={shot} alt={alt || "Fixlr product screenshot"} loading="lazy" decoding="async" className="block w-full h-auto" data-testid={`${testId}-img`} />
        </BrowserFrame>
      ) : PHONE_MOCKUPS.has(mockup) ? (
        <div className="py-6 flex justify-center"><Mockup name={mockup} /></div>
      ) : (
        <BrowserFrame url={url} className={cn(glow && "glow-lime")}><Mockup name={mockup} /></BrowserFrame>
      )}
    </div>
  );
};

export default ProductFrame;
